// ===================================
// NOTIFICATION UTILITIES
// ===================================


export const getNotificationIcon = (event: string): string => {
  switch (event) {
    case 'video_generated':
      return '✅';
    case 'video_uploaded':
      return '📤';
    case 'video_updated':
      return '🔄';
    case 'video_deleted':
      return '🗑️';
    case 'image_deleted':
      return '🗑️';
    case 'delete_request':
      return '🗑️';
    case 'admin_notification':
      return '🔔';
    case 'video_approved':
      return '✅';
    case 'video_rejected':
      return '❌';
    case 'new_video_submission':
      return '📝';
    default:
      return "";
  }
};

export const getNotificationColor = (event: string): string => {
  switch (event) {
    case 'video_generated':
      return '#4caf50';
    case 'video_uploaded':
      return '#2196f3';
    case 'video_updated':
      return '#ff9800';
    case 'video_deleted':
      return '#f44336';
    case 'image_deleted':
      return '#f44336';
    case 'delete_request':
      return '#f44336';
    case 'admin_notification':
      return '#9c27b0';
    case 'video_approved':
      return '#4caf50';
    case 'video_rejected':
      return '#f44336';
    case 'new_video_submission':
      return '#2196f3';
    default:
      return "";
  }
};

export const getNotificationTypeLabel = (event: string): string => {
  switch (event) {
    case 'video_generated':
      return 'Generated';
    case 'video_uploaded':
      return 'Uploaded';
    case 'video_updated':
      return 'Updated';
    case 'video_deleted':
      return 'Deleted';
    case 'image_deleted':
      return 'Deleted';
    case 'delete_request':
      return 'Delete Request';
    case 'admin_notification':
      return 'Admin';
    case 'video_approved':
      return 'Approved';
    case 'video_rejected':
      return 'Rejected';
    case 'new_video_submission':
      return 'New Submission';
    default:
      return "";
  }
};

export const getMuiNotificationSeverity = (event: string): 'success' | 'info' | 'warning' | 'error' => {
  switch (event) {
    case 'video_generated':
    case 'video_uploaded':
    case 'video_approved':
      return 'success';
    case 'video_updated':
    case 'admin_notification':
    case 'new_video_submission':
      return 'info';
    case 'video_deleted':
    case 'image_deleted':
    case 'video_rejected':
    case 'delete_request':
      return 'error';
    default:
      return 'info';
  }
};
